module.exports = __webpack_public_path__ + "img/across shoulders.4b975988.png";